import api from './api';

export interface Registration {
  id: number;
  name: string;
  phone: string;
  email: string;
  city: string | null;
  registerable_id: number;
  registerable_type: string;
  registerable?: { id: number; title?: string; company?: string; date?: string; time?: string };
  registration_date: string;
  known_in_welfare: boolean | null;
  salary_range: string | null;
  unemployed_over_year: boolean | null;
}

export const registrationService = {
  async list(params?: { type?: string }) {
    const { data } = await api.get<{ data: Registration[] }>('/registrations', { params });
    return data.data;
  },

  async get(id: number) {
    const { data } = await api.get<Registration>(`/registrations/${id}`);
    return data;
  },

  async create(payload: Partial<Registration>) {
    const { data } = await api.post<Registration>('/registrations', payload);
    return data;
  },

  async delete(id: number) {
    await api.delete(`/registrations/${id}`);
  },
};
